import { Component, Inject, Injectable } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'custom-snack-bar',
  template: `
    <div class="custom-snack-bar-content" (click)="onClick()" style="user-select: none; -webkit-user-select: none; -ms-user-select: none;">
      {{ data }}
    </div>
  `,
})
export class CustomSnackBarComponent {
  constructor(
    private snackBarRef: MatSnackBarRef<CustomSnackBarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: string
  ) {}

  onClick() {
    this.snackBarRef.dismiss();
  }
}

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  constructor(private snackBar: MatSnackBar) {}

  openSnackBarError(message: string, duration: number = 10000) {
    const ref = this.snackBar.openFromComponent(CustomSnackBarComponent, {
      duration: duration,
      verticalPosition: 'top',
      panelClass: 'snackbar-container-error',
      data: message,
    });
  }

  openSnackBarSuccess(message: string, duration: number = 10000) {
    const ref = this.snackBar.openFromComponent(CustomSnackBarComponent, {
      duration: duration,
      verticalPosition: 'top',
      panelClass: 'snackbar-container-success',
      data: message,
    });
  }
}
